import React from "react"
import { TextField, MenuItem } from "@mui/material"

import useLengthCombinationsBySystemConfiguration from "@secureo/common/hooks/cylinderConfigurations/useLengthCombinationsBySystemConfiguration"
import { LengthCombinationsBySystem } from "@secureo/common/typings/Product"
import { GridTemplateRowName } from "../LockingSystemMatrix"
import LockingSystemItemWrapper from "../LockingSystemItemWrapper"
import StyledLockingSystemCell from "../StyledLockingSystemCell"

const SystemAndLengthCombinationConfigurations = ({
	isLoading,
	uuid,
	gridRowName,
	selectedSystem,
	selectedOuterLength,
	selectedInnerLength,
	lengthCombinationsBySystem,
	setSelectedOuterLength,
	setSelectedInnerLength,
}: Props) => {
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	const onSystemChange = (selectedSystem: string) => {
		//
		alert("TODO")
	}

	const onOuterLengthChange = (selectedOuterLength: number) => {
		setSelectedOuterLength(uuid, selectedOuterLength)
	}

	const onInnerLengthChange = (selectedInnerLength: number) => {
		setSelectedInnerLength(uuid, selectedInnerLength)
	}

	const {
		outerLengthInputProps,
		innerLengthInputProps,
		availableOuterLengths,
		availableInnerLengths,
	} = useLengthCombinationsBySystemConfiguration(
		lengthCombinationsBySystem,
		selectedSystem,
		selectedOuterLength,
		selectedInnerLength,
		onSystemChange,
		onOuterLengthChange,
		onInnerLengthChange,
	)

	return (
		<>
			<StyledLockingSystemCell gridRowName={gridRowName} gridColumnName="outerLength">
				<LockingSystemItemWrapper>
					<TextField
						label="Außen"
						{...outerLengthInputProps}
						margin="normal"
						variant="filled"
						select
						fullWidth
						disabled={isLoading || !setSelectedOuterLength}
						style={{ marginTop: 0 }}
					>
						{availableOuterLengths.map((outerLength) => {
							return (
								<MenuItem key={outerLength} value={outerLength}>
									{outerLength} mm
								</MenuItem>
							)
						})}
					</TextField>
				</LockingSystemItemWrapper>
			</StyledLockingSystemCell>

			<StyledLockingSystemCell gridRowName={gridRowName} gridColumnName="innerLength">
				<LockingSystemItemWrapper>
					<TextField
						label="Innen"
						{...innerLengthInputProps}
						margin="normal"
						variant="filled"
						select
						fullWidth
						disabled={isLoading || !setSelectedInnerLength}
						style={{ marginTop: 0 }}
					>
						{availableInnerLengths.map((innerLength) => (
							<MenuItem key={innerLength} value={innerLength}>
								{innerLength} mm
							</MenuItem>
						))}
					</TextField>
				</LockingSystemItemWrapper>
			</StyledLockingSystemCell>
		</>
	)
}

interface Props {
	isLoading: boolean
	uuid: string
	gridRowName: GridTemplateRowName
	selectedSystem: string
	selectedOuterLength: number
	selectedInnerLength: number
	lengthCombinationsBySystem: LengthCombinationsBySystem
	setSelectedOuterLength?: (uuid: string, selectedOuterLength: number) => void
	setSelectedInnerLength?: (uuid: string, selectedOuterLength: number) => void
}

export default SystemAndLengthCombinationConfigurations
